module.exports = __webpack_public_path__ + "img/venn.98a4817e.png";